import { fetchLocalGovernmentFundIndividualReport } from '@/features/project/report/_hooks/report-individual';
import { t } from '@/i18n';
import { EMPTY_DATA_ERROR, downloadCsv } from '@/utils';
import { getFundOwnerForLocalGovernmentCsv } from '../../../../../mold/utils/fund-owner-for-local-government/get-csv';

export const downloadFundOwnerForLocalGovernmentReportCsv = async ({
  id,
  fiscalYear,
  projectName,
  isDebugMode,
}: {
  id: string;
  fiscalYear: number;
  projectName: string;
  isDebugMode: boolean;
}) => {
  const reportData = await fetchLocalGovernmentFundIndividualReport(id);

  if (!reportData.data.length) {
    throw new Error(EMPTY_DATA_ERROR);
  }

  const csvData = getFundOwnerForLocalGovernmentCsv({
    fiscalYear,
    reports: reportData,
    isDebugMode,
  });

  downloadCsv(
    csvData,
    t('report-fund-owner-for-local-government-individual-table-title', {
      year: fiscalYear,
      projectName,
    }),
  );
};
